import { render } from "./LegalDocument.vue?vue&type=template&id=7f8df076&scoped=true"
import script from "./LegalDocument.vue?vue&type=script&lang=js"
export * from "./LegalDocument.vue?vue&type=script&lang=js"

import "./LegalDocument.vue?vue&type=style&index=0&id=7f8df076&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f8df076"]])

export default __exports__